import styled from "styled-components";
import spacing from "theme/spacing.module.scss";
import { Button, Flex } from "antd";
import { ButtonProps } from "antd/lib/button";

export const StyledFlex = styled(Flex)`
  padding: 64px ${spacing.spacing} ${spacing.spacingXL} ${spacing.spacing};
  height: 65vh;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing.spacingSM};
`;

export const StyledButton = styled(Button)<ButtonProps>`
  border-radius: 4px;
  display: block;
`;
